/**
 * Map legacy /m/* bookmarks to shared-route paths (shell no longer uses /m).
 */

export function legacyMobilePathToShared(pathname: string): string | null {
  if (pathname !== '/m' && !pathname.startsWith('/m/')) return null;

  const rest =
    pathname === '/m' || pathname === '/m/'
      ? ''
      : pathname.slice('/m'.length); // starts with /

  const path = rest === '' || rest === '/' ? '/' : rest;

  // Known legacy surfaces → product IA
  if (path === '/' || path === '/alerts') return '/';
  if (path.startsWith('/niners')) return '/explorer';
  if (path === '/levels') return '/market';
  if (path === '/ratings' || path === '/congress' || path === '/more') return '/';
  if (path === '/settings') return '/profile';

  // /m/explorer → /explorer, etc.
  return path;
}
